import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { IDialogConfirm } from '@aca-new/app/shared/components/modal/shared/components/dialog-confirm/shared/interfaces/dialog-confirm.interface';
import { DIALOG_DATA } from '@aca-new/app/shared/components/modal/shared/tokens/dialog.token';
import { QimaButtonService } from '@aca-new/app/shared/services/exported-services/qima-button/qima-button.service';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmComponent {
  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) public readonly dialogData: IDialogConfirm,
    public readonly qimaButton: QimaButtonService
  ) {}

  public close(): void {
    this._dialogRef.close(false);
  }

  public confirm(): void {
    this._dialogRef.close(true);
  }
}
